// @flow
import * as React from 'react';

import * as destinationToSection from 'Components/utils/model/destinationToSection';

import { SiteContainer } from 'Components/frameworks/site-container/SiteContainer.jsx';
import SectionBlocks from 'Components/widgets/section-blocks/SectionBlocks.jsx';
import Sections from './Sections.jsx';

type Props = {
  discoverClubMed: *,
  destination: *,
  sections: string,
};

class SectionsBlocksContainer extends React.Component<Props> {
  renderSections(): Array<*> {
    return [
      {
        order: this.props.discoverClubMed.order,
        content: index => <Sections key={index} sections={this.props.sections} />,
      },
      {
        order: this.props.destination.order,
        content: index => {
          return (
            <div className="Line" id="destination" key={index}>
              <SiteContainer>
                <SectionBlocks
                  allBlocks={destinationToSection.build(this.props.destination)}
                  trackingData={{
                    actionGA: 'push_content',
                    labelGA: 'Destinations',
                  }}
                />
              </SiteContainer>
            </div>
          );
        },
      },
    ]
      .sort((a, b) => {
        return a.order - b.order;
      })
      .map((section, index) => section.content(index));
  }

  render() {
    return <div>{this.renderSections()}</div>;
  }
}

export default SectionsBlocksContainer;
